import { Product } from '@core/models/piramide/Product';
import { Alcance } from '@core/services/DiscountHandler/Model/Alcance';
import { Discount } from '@core/services/DiscountHandler/Model/Discount';
import { computed, signal } from '@angular/core';
import { PaymentMethodEnum } from '@core/enums/payment-methods.enum';

export class ProductCartClass {
  public idProduct: number;
  public idBuild: number;
  public priceList: number;
  public priceSpecial: number;
  public idBrand: number;
  public idSubcategory: number;
  public stock: number;
  public salable: boolean;
  public discountCode = signal<Discount>(null);
  public discountReach = signal<Alcance>(null);
  public observations = signal<string>('');
  public discountPriceList = computed<number>(() => {
    return this.calculateDiscount(this.priceList, this.discountReach(), this.discountCode());
  });
  public discountPriceSpecial = computed<number>(() => {
    return this.calculateDiscount(this.priceSpecial, this.discountReach(), this.discountCode());
  });
  public quantity = signal<number>(0);
  public totalPrice = computed(() => {
    const list = this.priceList - (this.discountPriceList() || 0);
    const special = this.priceSpecial - (this.discountPriceSpecial() || 0);
    const price = this.idTypePayment() == PaymentMethodEnum.TRANSFERENCIA_DEPOSITO ? special : list;
    return this.quantity() * price;
  });
  public idTypePayment = signal<number>(PaymentMethodEnum.TRANSFERENCIA_DEPOSITO);
  public productName: string;

  constructor(product: Product, quantity: number, idBuild?: number) {
    this.productName = product.nombre;
    this.priceList = product.precioLista;
    this.priceSpecial = product.precioEspecial;
    this.idProduct = product.id_producto;
    this.idBuild = idBuild;
    this.idBrand = product.id_marca;
    this.idSubcategory = product.id_subcategoria;
    this.quantity.set(quantity);
    this.stock = product.stock;
    this.salable = !!product.vendible;
  }

  public changeQuantity(quantity: number): void {
    this.quantity.set(quantity);
  }

  public addOneQuantity(): void {
    this.quantity.set(this.quantity() + 1);
  }

  public setTypePayment(idTypePayment) {
    this.idTypePayment.set(idTypePayment);
  }

  public resetDiscount(): void {
    this.discountCode.set(null);
    this.discountReach.set(null);
  }

  public setDiscountPrice(reach: Alcance, discount: Discount): void {
    this.discountCode.set(discount);
    this.discountReach.set(reach);
    const validityStart = new Date(discount.vigencias[0].fecha_desde);
    const validityEnd = new Date(discount.vigencias[0].fecha_hasta);
    const today = new Date().getTime();
    if (validityStart.getTime() < today && validityEnd.getTime() > today) {
    }
  }

  private calculateDiscount(price: number, reach: Alcance, discount: Discount): number {
    const discountPrice = (price * (reach?.porcentaje_alcance || discount?.porcentaje || 0)) / 100;
    return discountPrice > discount?.monto_maximo ? discount.monto_maximo : discountPrice;
  }

  public setObservation(observation: string): void {
    this.observations.set(observation);
  }
}
